// Values must match TypeEnrollmentSchedule in ae-core-api.
export const TypeEnrollment = [{
    id: 4,
    type: "Prematrícula",
    value: "P"
},{
    id: 2,
    type: "Matrícula de alumnos actuales",
    value: "O"
},{
    id: 3,
    type: "Matrícula de alumnos nuevos",
    value: "N"
},{
    id: 1,
    type: "Ratificación (sin uso)",
    value: "R"
}]
